import React, { useState } from 'react';
import styled from 'styled-components';
import moment from 'moment';

import Popover from 'antd/es/popover';
import Divider from 'antd/es/divider';

import { Space } from 'components/layout';
import Button from 'components/Button';

import TimePicker from './TimePicker';
import { useEffect } from 'react';

const FooterDivider = styled(Divider)`
  margin: 16px 0;
`;

const BreakPopover = React.memo((props) => {
  const { breakHour, onDelete, onCancel, onSave, ...rest } = props;
  const [show, setShow] = useState(false);
  const [breakTime, setBreakTime] = useState({
    start: null,
    end: null,
  });

  useEffect(() => {
    if (breakHour) {
      setBreakTime({
        start: moment.utc(breakHour.start_hr * 3600 * 1000),
        end: moment.utc(breakHour.end_hr * 3600 * 1000),
      });
    } 
  }, [breakHour]);

  return (
    <Popover
      placement='right'
      title='Break Time'
      minuteStep={30}
      onClose={() => {
        if (onCancel) onCancel();
        setShow(false);
      }}
      trigger="click"
      onVisibleChange={show => {
        if (show === false) {
          if (onCancel) onCancel();
        }
        setShow(show);
      }}
      visible={show}
      content={(
        <>
          <TimePicker
            value={[breakTime.start, breakTime.end]}
            allowClear={false}
            onChange={time => {
              setBreakTime({ start: time[0], end: time[1] });
            }}
          />
          <FooterDivider type="horizontal" />
          <Space>
            <Button
              key="delete"
              onClick={e => {
                if (onDelete) onDelete();
                setShow(false);
              }}
              style={{
                color: '#F5222D'
              }}
            >
              Delete
            </Button>
            <Button key="back" onClick={e => {
              if (onCancel) onCancel();
              setShow(false);
            }}>
              Cancel
            </Button>
            <Button key="submit" type="primary" onClick={e => {
              if (onSave) onSave(breakTime);
              setShow(false);
            }}>
              Save
            </Button>
          </Space>
        </>
      )}
      {...rest}
    >
      <div id="break-popover" style={{ width: '100%', height: '100%' }}>
        {breakTime.start && breakTime.start.format('h:mm')}-
        {breakTime.end && breakTime.end.format('h:mm')}
      </div>
    </Popover>
  );
});

export default BreakPopover;
